import { Button, Text } from '@chakra-ui/react';
import React from 'react';
import DynamicIcon from '../../icons';
import { useTokens } from '../../../context/TokenProvider';
import VStackWrapper from '../VStackWrapper/VStackWrapper';
export const SidebarItem = (props) => {
    const { PrimaryNavigationWebIconUnselected, PrimaryNavigationWebIconSelected, } = useTokens();
    const variant = props.selected
        ? 'sidebar-item-selected'
        : 'sidebar-item-unselected';
    const iconFill = props.selected
        ? PrimaryNavigationWebIconSelected
        : PrimaryNavigationWebIconUnselected;
    const onClick = (e) => {
        e.preventDefault();
        if (props.onClick) {
            props.onClick();
        }
    };
    return (React.createElement(Button, { tabIndex: 0, type: "button", onClick: onClick, "aria-pressed": props.selected, "data-selected": props.selected, "data-testid": "sidebar-item", "aria-label": props.labelName, variant: "nav", role: "button" },
        React.createElement(VStackWrapper, { variant: variant, gap: 0 },
            React.createElement(DynamicIcon, { icon: props.icon, fill: iconFill }),
            React.createElement(Text, { variant: variant }, props.children))));
};
